import React from 'react'

/**
 * Status options for ProcessFlow elements
 */
export type ProcessFlowStatus = 'CURRENT' | 'UPCOMING' | 'COMPLETED'

/**
 * Size options for ProcessFlow elements
 */
export type ProcessFlowSize = 'sm' | 'md'

/**
 * Direction options for ProcessFlow
 */
export type ProcessFlowDirection = 'vertical' | 'horizontal'

/**
 * Props for ProcessFlow component
 */
export interface ProcessFlowProps {
    /**
     * Array of steps in the process flow
     */
    steps: {
        /**
         * Title of the step
         */
        title: string
        /**
         * Optional subtitle for the step
         */
        subtitle?: string
    }[]
    /**
     * The current active step (zero-based index)
     */
    activeStep: number
    /**
     * Size of the process flow elements
     * @default 'md'
     */
    size?: ProcessFlowSize
    /**
     * Direction of the process flow
     * @default 'vertical'
     */
    direction?: ProcessFlowDirection
    /**
     * Optional color override for the whole stepper (e.g., 'green', 'red', hex, or theme color)
     */
    color?: string
}

/**
 * Props for ProcessFlowCircle component
 */
export interface ProcessFlowCircleProps {
    /**
     * Status of the circle (current/upcoming/completed)
     * @default 'UPCOMING'
     */
    status?: ProcessFlowStatus
    /**
     * Size of the circle
     * @default 'md'
     */
    size?: ProcessFlowSize
    /**
     * Optional className for styling
     */
    className?: string
    /**
     * Optional test ID for testing
     */
    testId?: string
    /**
     * Optional children to render inside the circle
     */
    children?: React.ReactNode
    /**
     * Optional color override for the circle (e.g., 'green', 'red', hex, or theme color)
     */
    color?: string
}

/**
 * Props for ProcessFlowDivider component
 */
export interface ProcessFlowDividerProps {
    /**
     * Status of the divider (current/upcoming/completed)
     * @default 'UPCOMING'
     */
    status?: ProcessFlowStatus
    /**
     * Direction of the divider
     * @default 'vertical'
     */
    direction?: ProcessFlowDirection
    /**
     * Size of the divider
     * @default 'md'
     */
    size?: ProcessFlowSize
    /**
     * Optional className for styling
     */
    className?: string
    /**
     * Optional test ID for testing
     */
    testId?: string
    /**
     * Optional color override for the divider (e.g., 'green', 'red', hex, or theme color)
     */
    color?: string
}
